module.exports = __webpack_public_path__ + "place-green.png?4f782e677587d6e5ce77992e41b38408";


//////////////////
// WEBPACK FOOTER
// ./images/place-green.png
// module id = 175
// module chunks = 0